export default __webpack_public_path__ + "a9c53aa0e9bbf285937f79cb22fb7ee9.svg";